import { NavLink } from 'react-router-dom';
import { RootState } from '../../../../../redux/store';
import { useAppSelector } from '../../../../hooks';
import DropdownNavigation from '../DropdownMenu';
import styles from './SideMenu.module.css';
import { ReactComponent as UserIcon } from '../SideMenu/assets/user.svg';
import { ReactComponent as EllipseIcon } from '../SideMenu/assets/ellipse.svg';
import { ReactComponent as AirplaneIcon } from '../SideMenu/assets/airplane.svg';
import { ReactComponent as CartIcon } from '../SideMenu/assets/cart.svg';
import { ReactComponent as BookmarkIcon } from '../SideMenu/assets/bookmark.svg';
import { ReactComponent as PenIcon } from '../SideMenu/assets/pen.svg';
import { useAuth } from 'oidc-react';
import { useState } from 'react';
import PhotoModal from './components/PhotoModal';
import { IProfilePhoto } from '../../../../../models/Profile/IProfilePhoto';
import { UserStatus } from '../../../../../models/enums';

type SideMenuProps = {
  onDeletePhoto: (id: number, ssoUUID: string) => Promise<unknown>;
  onUploadPhoto: (profilePhoto: IProfilePhoto) => Promise<unknown>;
};

const SideMenu = (props: SideMenuProps) => {
  const profile = useAppSelector((state: RootState) => state.profileReducer.profileContainer);
  const profilePhoto = useAppSelector((state: RootState) => state.profileReducer.profilePhoto);
  const isMock = window.name === 'true';
  const [showModal, setShowModal] = useState(false);

  const userStatus: UserStatus = useAppSelector(
    (state: RootState) => state.accountReducer.userStatus
  );

  const auth = isMock ? null : useAuth();

  const handleEditPhoto = () => {
    setShowModal(true);
  };

  const handleEditPhotoClose = () => {
    setShowModal(false);
  };

  const handleDeletePhoto = () => {
    return props.onDeletePhoto(profilePhoto?.profilePhotoId, profilePhoto?.ssouuId);
  };

  const handleUploadPhoto = (profilePhoto: IProfilePhoto) => {
    profilePhoto.ssouuId = profile.profileModel.masterCustomerId;
    return props.onUploadPhoto(profilePhoto);
  };

  const memberOnlyDisabled = () => {
    if (
      userStatus === UserStatus.GracePeriodMember ||
      userStatus === UserStatus.ExpiringMember ||
      userStatus === UserStatus.Member
    ) {
      return false;
    } else {
      return true;
    }
  };

  if (isMock || (auth && auth.userData)) {
    return (
      <>
        {showModal && (
          <PhotoModal
            profilePhoto={profilePhoto}
            phoneModalClose={handleEditPhotoClose}
            onDeletePhoto={handleDeletePhoto}
            onUploadPhoto={handleUploadPhoto}
          />
        )}
        <div className={styles.container}>
          <div className={styles.profilePhotoContainer}>
            {profilePhoto?.photoLink ? (
              <>
                <img className={styles.profilePhoto} src={profilePhoto?.photoLink} />
                <PenIcon onClick={handleEditPhoto} className={styles.profilePhotoEdit} />
              </>
            ) : (
              <>
                <img
                  className={styles.profilePhoto}
                  src={process.env.PUBLIC_URL + 'default-profile-picture.png'}
                />
                <PenIcon onClick={handleEditPhoto} className={styles.profilePhotoEdit} />
              </>
            )}
          </div>
          <div className={styles.navigationContainer}>
            <div className={styles.nameLabel}>
              {profile?.profileModel?.firstName} {profile?.profileModel?.lastName}
            </div>
            <div className={styles.positionLabel}>{profile?.profileModel?.jobTitle}</div>
            <hr className={styles.divider} />
            <DropdownNavigation />
            <nav className={styles.navigationLinksContainer}>
              <NavLink
                to='/account'
                className={({ isActive }) =>
                  isActive ? styles.navigationActiveItemContainer : styles.navigationItemContainer
                }
              >
                <UserIcon className={styles.user} />
                <div className={styles.navigationLinkLabel}>Account</div>
              </NavLink>

              <NavLink
                to='/profile'
                className={({ isActive }) =>
                  isActive ? styles.navigationActiveItemContainer : styles.navigationItemContainer
                }
              >
                <EllipseIcon className={styles.ellipse} />
                <div className={styles.navigationLinkLabel}>Profile</div>
              </NavLink>

              <NavLink
                to='/newsletters'
                className={({ isActive }) =>
                  isActive ? styles.navigationActiveItemContainer : styles.navigationItemContainer
                }
              >
                <AirplaneIcon className={styles.airplane} />
                <div className={styles.navigationLinkLabel}>Newsletters</div>
              </NavLink>

              <NavLink
                to='/orders'
                className={({ isActive }) =>
                  isActive ? styles.navigationActiveItemContainer : styles.navigationItemContainer
                }
              >
                <CartIcon className={styles.cart} />
                <div className={styles.navigationLinkLabel}>Orders &amp; Donations</div>
              </NavLink>

              {memberOnlyDisabled() && (
                <a className={styles.navigationItemDisabledContainer} title='Member Only Feature'>
                  <BookmarkIcon className={styles.bookmark} />
                  <div className={styles.navigationLinkLabel}>Bookmarks</div>
                </a>
              )}
              {!memberOnlyDisabled() && (
                <NavLink
                  to='/bookmarks'
                  className={({ isActive }) =>
                    isActive ? styles.navigationActiveItemContainer : styles.navigationItemContainer
                  }
                >
                  <BookmarkIcon className={styles.bookmark} />
                  <div className={styles.navigationLinkLabel}>Bookmarks</div>
                </NavLink>
              )}
            </nav>
          </div>
        </div>
      </>
    );
  }
  return (
    <div>
      <></>
    </div>
  );
};

export default SideMenu;
